import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreHorizontal } from "lucide-react";
import { useNavigate } from 'react-router-dom';

export function MonitorListItem({ 
  monitor,
  className,
  onMonitorUpdate,
  columnConfig = {
    status: true,
    name: true,
    responseTime: true,
    lastRun: true,
    actions: true
  },
  ...props 
}) {
  const navigate = useNavigate();

  const handleRowClick = (e) => {
    if (e.target.closest('.monitor-action')) {
      e.stopPropagation();
      return;
    }
    navigate(`/monitors/${monitor.formatted.id}`);
  };

  // Build grid columns dynamically based on config
  const getGridTemplateColumns = () => {
    const columns = [];
    if (columnConfig.status) columns.push('auto');
    if (columnConfig.name) columns.push('1fr');
    if (columnConfig.responseTime) columns.push('120px');
    if (columnConfig.lastRun) columns.push('200px');
    if (columnConfig.actions) columns.push('48px');
    return columns.join(' ');
  };

  return (
    <div
      onClick={handleRowClick}
      className={`grid gap-4 items-center p-3 rounded-lg dark:bg-muted/20 dark:hover:bg-muted/60 bg-muted/60 hover:bg-muted/90 h-16 
        cursor-pointer transition-colors ${className}`}
      style={{ gridTemplateColumns: getGridTemplateColumns() }}
      {...props}
    >
      {columnConfig.status && (
        <div className="relative">
          <div className={`w-2.5 h-2.5 rounded-full ${
            monitor.formatted.status.toLowerCase() === 'running' ? 'bg-emerald-400' : 'bg-yellow-500'
          }`}></div>
          {monitor.formatted.status.toLowerCase() === 'running' && (
            <div className="absolute inset-0 w-2.5 h-2.5 bg-emerald-400 rounded-full animate-ping" />
          )}
        </div>
      )}

      {columnConfig.name && (
        <div className="text-sm font-medium">{monitor.formatted.name}</div>
      )}

      {columnConfig.responseTime && (
        <div className="text-sm text-muted-foreground">
          {monitor.formatted.lastRun?.responseTime ? `${monitor.formatted.lastRun.responseTime} ms` : 'N/A'}
        </div>
      )}

      {columnConfig.lastRun && (
        <div className="text-sm">
          {monitor.formatted.lastRun ? (
            <div>
              <span className={
                monitor.formatted.lastRun.success ? 'text-emerald-400' : 'text-red-400'
              }>
                {monitor.formatted.lastRun.success ? 'Success' : 'Failed'}
              </span>
              <div className="text-xs text-muted-foreground">
                {monitor.formatted.lastRun.startTime}
              </div>
            </div>
          ) : (
            <span className="text-muted-foreground">No runs yet</span>
          )}
        </div>
      )}

      {columnConfig.actions && (
        <div className="monitor-action">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="icon" className="h-8 w-8">
                <MoreHorizontal className="h-4 w-4" />
                <span className="sr-only">Open menu</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => navigate(`/monitors/${monitor.formatted.id}/edit`)}>
                Edit
              </DropdownMenuItem>
              <DropdownMenuItem className="text-destructive">Delete</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
    </div>
  );
} 